module.exports = __webpack_public_path__ + "static/media/account_balance_black.3e2c217e.svg";